import { useTranslation } from "react-i18next";
import { Agency } from "../../models/Agency"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../state/store";
import { SubmitHandler, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { updateAgency } from "../../state/agencies/action";
import { setCurrentUserAgency } from "../../state/users/actions";
import { Toast } from "../Toast";
import { toast, ToastContainer } from "react-toastify";
import { LoadingMask } from "../LoadingMask";
import { Form } from "../form/Form";
import { ReactiveFormInput } from "../form/ReactiveFormInput";
import Button from "../Button";
import { CheckIcon } from "@heroicons/react/24/outline";

export const AgencyInformationModule = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const currentAgency = useSelector((state: any) => state.users.currentUser?.agency);
    const [showError, setShowError] = useState(false);
    const [isAgencyLoading, setIsAgencyLoading] = useState(false);
    const error = useSelector((state: any) => state.agencies.error);

    useEffect(() => {
        if (showError) {
          Toast(t(error?.reason ?? "SOMETHING_WENT_WRONG"), t(error?.cause_info));
          setShowError(false);
        }
    }, [showError, error, t]);

    const methods = useForm<Agency>({
        defaultValues: currentAgency,
    });

    const { handleSubmit, control, reset } = methods;

    useEffect(() => {
        reset(currentAgency);
    }, [currentAgency, reset]);

    const onSubmit: SubmitHandler<Agency> = async (data: Agency) => {
        console.log(data);
        setIsAgencyLoading(true);
        dispatch(updateAgency(data)).then((e) => {
          if (e.type === "agencies/update/rejected") {
            dispatch(setCurrentUserAgency(data));
            setShowError(true);
            setIsAgencyLoading(false);
          } else {
            toast(t("SAVED_SUCCESFULLY"));
            setIsAgencyLoading(false);
          }
        });
    };

    return(
        <>
            {isAgencyLoading && <LoadingMask />}
            <ToastContainer progressStyle={{ background: "#D4AF37" }} />
            <Form handleOnSubmit={handleSubmit(onSubmit)}>
                <div className="text-black max-h-full w-screen md:w-full">
                    <div className="text-xl font-bold text-black pl-3">{t("AGENCY")}</div>
                    <div className="pb-5 pt-5  w-full flex flex-wrap">
                        <ReactiveFormInput
                            control={control}
                            className="md:w-1/2"
                            label={t("NAME")}
                            name="name"
                            isRequired
                        />
                        <ReactiveFormInput
                            control={control}
                            className="md:w-1/2"
                            label={t("FEDERAL_TAX_NUMBER")}
                            name="federal_tax_number"
                        />
                        <ReactiveFormInput
                            control={control}
                            label={t("NOTES")}
                            name="notes"
                        />
                    </div>
                    <div className="pb-5 pr-3 text-right">
                        <Button onClick={handleSubmit(onSubmit)}>
                            <span className="flex items-center font-semibold pr-3">
                                <div className="w-8 p-1 aspect-square mr-2">
                                    <CheckIcon />
                                </div>
                                {t("SAVE")}
                            </span>
                        </Button>
                    </div>
                </div>
            </Form>
        </>
    )
}